/**
 * Cautarea fara diacritice si fara litere mari (04.11.2026): „sofer" gaseste „Șofer". Aceeasi
 * regula in API (in TS si, ca variante in expresia regulata, in SQL) si in ecran.
 */
/** Litera cu semn → litera fara, pe pozitii. Si sedila veche (ş ţ), nu doar virgula (ș ț). */
export const LITERE_CU_SEMNE = 'ĂÂÎȘŞȚŢăâîșşțţÁÀÄÉÈËÍÌÏÓÒÖÚÙÜÇáàäéèëíìïóòöúùüç';
export const LITERE_FARA_SEMNE = 'AAISSTTaaisstt' + 'AAAEEEIIIOOOUUUC' + 'aaaeeeiiiooouuuc';
const SEMN = new Map([...LITERE_CU_SEMNE].map((c, i) => [c, LITERE_FARA_SEMNE[i]]));
/**
 * Fara diacritice si cu litere mici, cu ACEEASI lungime: pozitiile din textul normalizat sunt si
 * pozitiile din original — asa se evidentiaza cuvantul gasit.
 */
export function normalizeaza(s) {
    let r = '';
    for (const c of s) {
        const f = SEMN.get(c);
        if (f) {
            r += f.toLowerCase();
            continue;
        }
        const m = c.toLowerCase();
        r += m.length === c.length ? m : c;
    }
    return r;
}
//# sourceMappingURL=cautare.js.map